export const capitalize = (string: string | undefined): string => {
  if (!string?.length) {
    return '';
  }
  return string.charAt(0).toLocaleUpperCase() + string.slice(1).toLocaleLowerCase();
};

export function numToPostfix(value: number, words: string[]) {
  const absValue = Math.abs(value);
  value = absValue % 100;
  var num = value % 10;
  if (value > 10 && value < 20) return words[2];
  // eslint-disable-next-line no-bitwise
  if ((num > 1 && num < 5) || absValue % ~~absValue !== 0) return words[1];
  if (num === 1) return words[0];
  return words[2];
}
